import { useEffect, useRef, useState } from 'react';
import { StandaloneSearchBox, useLoadScript } from '@react-google-maps/api';
import { Input } from 'reactstrap';
import { useKeysStore } from '../../../../../../store/useKeysStore';

const libraries = ['places'];

export function AddressAutoComplete(props) {
    const { keys } = useKeysStore();
    const [value, updateValue] = useState(props.value?.fullAddress);
    const inputRef = useRef();
    let className = '';

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: keys?.gmaps_key,
        libraries,
    });

    const handlePlacesChanged = () => {
        const [place] = inputRef.current.getPlaces();
        if (place) {
            const latLngResponse = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            updateValue(place.formatted_address);
            const target = {
                name: props.name,
                value: {
                    fullAddress: place.formatted_address,
                    lat: latLngResponse.lat,
                    lng: latLngResponse.lng,
                },
            };
            props.onChange({ target });
        }
    };

    const handleChange = (element) => {
        updateValue(element.target.value);
    };

    if (props.error) {
        className = 'is-invalid';
    }

    useEffect(() => {
        updateValue(props.value?.fullAddress);
    }, [props.value]);

    return (
        <td>
            {isLoaded && (
                <StandaloneSearchBox
                    onLoad={(ref) => (inputRef.current = ref)}
                    onPlacesChanged={handlePlacesChanged}
                >
                    <Input
                        id={'id_' + props.name}
                        className={className}
                        value={value}
                        onChange={handleChange}
                        type={props.type}
                        name={props.name}
                        readOnly={props.readOnly}
                        autoFocus={props.autoFocus ? true : false}
                        maxLength={props.maxLength}
                        placeholder="Digite um endereço"
                    />
                </StandaloneSearchBox>
            )}
        </td>
    );
}
